<template>
  <div>
    <!-- Website -->
    <div style="background:#E9ECF0" v-if="!MobileSize && !IpadSize">
      <v-container>
        <v-row dense justify="center" align-content="center">
          <!-- <v-col cols="6" md="7" class="my-16">
            <v-img :src="require('@/assets/icons/Login_BG.png')" contain></v-img>
          </v-col> -->
          <v-col cols="6" md="12" align="center" class="my-16">
            <v-card width="480px" height="514px" style="background: #FFFFFF; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1); border-radius: 12px;">
              <!-- <v-tabs
                color="#27AB9C"
                grow
              >
                <v-tab v-for="(item, index) in itemsLogin" :key="index">
                  <span style="padding-top: 0.5em; font-weight: bold; font-size: 18px; line-height: 30px;">{{ item }}</span>
                </v-tab>
                <v-tab-item class="mt-6"> -->
                  <v-card-text>
                    <v-container>
                      <!-- <v-row dense justify="center" align-content="center" class="mt-8 mb-8">
                        <v-img :src="require('@/assets/logo_one.png')" max-height="40%" max-width="40%" contain/>
                      </v-row> -->
                      <v-row dense justify="center" align-content="center" class="mt-16 mb-8">
                        <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">เข้าสู่ระบบ</span>
                      </v-row>
                      <v-row no-gutters dense class="mx-8">
                        <v-col cols="12" md="12" sm="12">
                          <v-btn @click="Login()" color="#27AB9C" block outlined rounded elevation="4" style="border: 1px solid #27AB9C; border-radius: 32px;"><v-img :src="require('@/assets/logo_one.png')" max-height="30" max-width="45" contain style="margin-right: 6px;"/> เข้าสู่ระบบด้วย one id</v-btn>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-8">
                          <v-row dense align="center">
                          <v-divider class="mr-2"></v-divider>หรือ<v-divider class="ml-2"></v-divider>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-8">
                          <v-btn @click="LoginWithOTP()" color="#27AB9C" block outlined rounded elevation="4" style="border: 1px solid #27AB9C; border-radius: 32px;">เข้าสู่ระบบด้วยหมายเลขโทรศัพท์</v-btn>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-16">
                          <v-row dense justify="center" align-content="center">
                            <span style="font-size: 14px; line-height: 22px; color: #000000;">คุณยังไม่มีบัญชีผู้ใช้ ใช่หรือไม่? <span style="color: #1E90FF; cursor: pointer;" @click="link('Register')">ลงทะเบียน</span></span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                <!-- </v-tab-item> -->
                <v-tab-item class="mt-6">
                  <v-card-text>
                    <v-container>
                      <v-form ref="Loginform" :lazy="lazy">
                        <v-row dense justify="center" align-content="center" class="mt-4 mb-8">
                          <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">เข้าสู่ระบบ</span>
                        </v-row>
                        <v-row no-gutters dense class="mx-8">
                          <!-- ชื่อผู้ใช้งาน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-text-field v-model="username" placeholder="ชื่อผู้ใช้หรืออีเมลของคุณ" outlined dense required :rules="Rules.name"></v-text-field>
                          </v-col>
                          <!-- รหัสผ่าน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-text-field v-model="password" placeholder="รหัสผ่านของคุณ" outlined dense required :rules="Rules.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                          </v-col>
                          <!-- จดจำฉันไว้ในระบบ & ลืมรหัสผ่าน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-row dense no-gutters>
                              <v-checkbox
                                v-model="checkbox"
                                dense
                                label="จดจำฉันไว้ในระบบ"
                                class="mt-0 pt-0"
                                color="rgb(0, 142, 0)"
                              ></v-checkbox>
                              <v-spacer></v-spacer>
                              <!-- <span style="font-size: 14px; line-height: 22px; text-decoration-line: underline; color: #1B5DD6; cursor: pointer;" @click="forgetPassword('UPS/forgetPassword')">ลืมรหัสผ่าน</span> -->
                            </v-row>
                          </v-col>
                          <!-- ปุ่มเข้าสู่ระบบ -->
                          <v-col cols="12" md="12" sm="12">
                            <v-btn block rounded color="#27AB9C" dark elevation="6" style="border-radius: 32px; font-size: 18px;" @click="LoginMarket()">เข้าสู่ระบบ</v-btn>
                          </v-col>
                          <!-- คุณยังไม่มีบัญชีผู้ใช้ ใช่หรือไม่? ลงทะเบียน -->
                          <!-- <v-col cols="12" md="12" sm="12" class="mt-8">
                            <v-row dense justify="center" align-content="center">
                              <span style="font-size: 14px; line-height: 22px; color: #000000;">คุณยังไม่มีบัญชีผู้ใช้ ใช่หรือไม่? <span style="color: #1E90FF; cursor: pointer;" @click="link('UPS/Register')">ลงทะเบียน</span></span>
                            </v-row>
                          </v-col> -->
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-tab-item>
              <!-- </v-tabs> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- IPAD -->
    <div style="background: #E9ECF0;" v-else-if="!MobileSize && IpadSize">
      <v-container>
        <v-row dense justify="center" align-content="center" class="my-16">
          <!-- <v-col cols="6" class="my-16">
            <v-img src="require('@/assets/icons/login_logo_Ipad.png')" contain max-width="100%" max-height="100%"></v-img>
          </v-col> -->
          <!-- <v-col cols="12" class="my-16" style="z-index: 1;"> -->
            <v-card width="60%" height="514px" style="background: #FFFFFF; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1); border-radius: 12px;">
              <!-- <v-tabs
                color="#27AB9C"
                grow
              >
                <v-tab v-for="(item, index) in itemsLogin" :key="index">
                  <span style="padding-top: 0.5em; font-weight: bold; font-size: 16px; line-height: 30px;">{{ item }}</span>
                </v-tab>
                <v-tab-item class="mt-6"> -->
                  <v-card-text>
                    <v-container>
                      <v-row dense justify="center" align-content="center" class="mt-16 mb-8">
                        <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">เข้าสู่ระบบ</span>
                      </v-row>
                      <v-row no-gutters dense class="mx-8">
                        <v-col cols="12" md="12" sm="12">
                          <v-btn @click="Login()" color="#27AB9C" block outlined rounded elevation="4" style="border: 1px solid #27AB9C; border-radius: 32px;"><v-img :src="require('@/assets/logo_one.png')" max-height="30" max-width="45" contain style="margin-right: 10px;"/>เข้าสู่ระบบด้วย one id</v-btn>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-8">
                          <v-row dense align="center">
                          <v-divider class="mr-2"></v-divider>หรือ<v-divider class="ml-2"></v-divider>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-8">
                          <v-btn @click="LoginWithOTP()" color="#27AB9C" block outlined rounded elevation="4" style="border: 1px solid #27AB9C; border-radius: 32px;">เข้าสู่ระบบด้วยหมายเลขโทรศัพท์</v-btn>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-16">
                          <v-row dense justify="center" align-content="center">
                            <span style="font-size: 14px; line-height: 22px; color: #000000;">คุณยังไม่มีบัญชีผู้ใช้ ใช่หรือไม่? <span style="color: #1E90FF; cursor: pointer;" @click="link('Register')">ลงทะเบียน</span></span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                <!-- </v-tab-item> -->
                <v-tab-item class="mt-6">
                  <v-card-text>
                    <v-container>
                      <v-form ref="Loginform" :lazy="lazy">
                        <v-row dense justify="center" align-content="center" class="mt-4 mb-8">
                          <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">เข้าสู่ระบบ</span>
                        </v-row>
                        <v-row no-gutters dense class="mx-8">
                          <!-- ชื่อผู้ใช้งาน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-text-field v-model="username" placeholder="ชื่อผู้ใช้หรืออีเมลของคุณ" outlined dense required :rules="Rules.name"></v-text-field>
                          </v-col>
                          <!-- รหัสผ่าน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-text-field v-model="password" placeholder="รหัสผ่านของคุณ" outlined dense required :rules="Rules.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                          </v-col>
                          <!-- จดจำฉันไว้ในระบบ & ลืมรหัสผ่าน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-row dense no-gutters>
                              <v-checkbox
                                v-model="checkbox"
                                dense
                                label="จดจำฉันไว้ในระบบ"
                                class="mt-0 pt-0"
                                color="rgb(0, 142, 0)"
                              ></v-checkbox>
                              <v-spacer></v-spacer>
                              <span style="font-size: 14px; line-height: 22px; text-decoration-line: underline; color: #1B5DD6; cursor: pointer;" @click="forgetPassword('UPS/forgetPassword')">ลืมรหัสผ่าน</span>
                            </v-row>
                          </v-col>
                          <!-- ปุ่มเข้าสู่ระบบ -->
                          <v-col cols="12" md="12" sm="12">
                            <v-btn block rounded color="#27AB9C" dark elevation="6" style="border-radius: 32px; font-size: 18px;" @click="LoginMarket()">เข้าสู่ระบบ</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-tab-item>
              <!-- </v-tabs> -->
            </v-card>
          <!-- </v-col> -->
        </v-row>
      </v-container>
    </div>
    <!-- App -->
    <div style="background: #E9ECF0;" v-if="MobileSize">
      <v-container class="py-8">
        <v-row dense justify="center" align-content="center">
          <v-col cols="12" md="12" class="d-flex justify-center">
            <v-card width="343px" height="510px"  style="background: #FFFFFF; box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1); border-radius: 12px;">
              <!-- <v-tabs
                color="#27AB9C"
                grow
              >
                <v-tab v-for="(item, index) in itemsLogin" :key="index" style="margin-left:-10px">
                  <span style="padding-top: 0.5em; font-weight: bold; font-size: 16px; line-height: 24px;margin-left:-1px">{{ item }}</span>
                </v-tab>
                <v-tab-item class="mt-6"> -->
                  <v-card-text>
                    <v-container>
                      <v-row dense justify="center" align-content="center" class="mt-16 mb-8">
                        <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">เข้าสู่ระบบ</span>
                      </v-row>
                      <v-row no-gutters dense>
                        <v-col cols="12" md="12" sm="12">
                          <v-btn @click="Login()" color="#27AB9C" block outlined rounded elevation="4" style="border: 1px solid #27AB9C; border-radius: 32px;"><v-img :src="require('@/assets/logo_one.png')" max-height="30" max-width="45" contain style="margin-right: 5px;"/>เข้าสู่ระบบด้วย one id</v-btn>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-8">
                          <v-row dense align="center">
                          <v-divider class="mr-2"></v-divider>หรือ<v-divider class="ml-2"></v-divider>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-8">
                          <v-btn @click="LoginWithOTP()" color="#27AB9C" block outlined rounded elevation="4" style="border: 1px solid #27AB9C; border-radius: 32px;">เข้าสู่ระบบด้วยหมายเลขโทรศัพท์</v-btn>
                        </v-col>
                        <v-col cols="12" md="12" sm="12" class="mt-16">
                          <v-row dense justify="center">
                            <span style="font-size: 14px; line-height: 22px; color: #000000; text-align: center;">คุณยังไม่มีบัญชีผู้ใช้ ใช่หรือไม่? <br/><span style="color: #1E90FF; cursor: pointer;" @click="link('Register')">ลงทะเบียน</span></span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                <!-- </v-tab-item> -->
                <v-tab-item class="mt-6">
                  <v-card-text>
                    <v-container>
                      <v-form ref="Loginform" :lazy="lazy">
                        <v-row dense justify="center" align-content="center" class="mt-4 mb-8">
                          <span style="font-weight: bold; font-size: 24px; line-height: 32px; color: #000000;">เข้าสู่ระบบ</span>
                        </v-row>
                        <v-row no-gutters dense class="mx-8">
                          <!-- ชื่อผู้ใช้งาน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-text-field v-model="username" placeholder="ชื่อผู้ใช้หรืออีเมลของคุณ" outlined dense required :rules="Rules.name"></v-text-field>
                          </v-col>
                          <!-- รหัสผ่าน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-text-field v-model="password" placeholder="รหัสผ่านของคุณ" outlined dense required :rules="Rules.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                          </v-col>
                          <!-- จดจำฉันไว้ในระบบ & ลืมรหัสผ่าน -->
                          <v-col cols="12" md="12" sm="12">
                            <v-row dense no-gutters>
                              <v-checkbox
                                v-model="checkbox"
                                dense
                                label="จดจำฉันไว้ในระบบ"
                                class="mt-0 pt-0"
                                color="rgb(0, 142, 0)"
                              ></v-checkbox>
                              <v-spacer></v-spacer>
                              <span style="font-size: 14px; line-height: 22px; text-decoration-line: underline; color: #1B5DD6; cursor: pointer;" @click="forgetPassword('forgetPassword')">ลืมรหัสผ่าน</span>
                            </v-row>
                          </v-col>
                          <!-- ปุ่มเข้าสู่ระบบ -->
                          <v-col cols="12" md="12" sm="12">
                            <v-btn block rounded color="#27AB9C" dark elevation="6" style="border-radius: 32px; font-size: 18px;" @click="LoginMarket()">เข้าสู่ระบบ</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-tab-item>
              <!-- </v-tabs> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Encode } from '@/services'
export default {
  data () {
    return {
      lazy: false,
      username: '',
      password: '',
      Oneusername: '',
      Onepassword: '',
      show1: false,
      checkbox: false,
      Rules: {
        empty: [v => !!v || 'กรุณาเลือกข้อมูล'],
        name: [
          v => !!v || 'กรุณากรอกชื่อผู้ใช้หรืออีเมล'
        ],
        password: [
          v => !!v || 'กรุณากรอกรหัสผ่าน'
        ],
        email: [
          v => !!v || 'กรุณากรอกอีเมล',
          v => /.+@.+\..+/.test(v) || 'กรุณากรอกอีเมลให้ถูกต้อง',
          v => /^[A-Za-z0-9_@.,/#&+-\s]+$/.test(v) || 'กรุณากรอกเฉพาะภาษาอังกฤษ',
          v => /^\S*$/.test(v) || 'ห้ามใส่ช่องว่างในอีเมล'
        ],
        tel: [
          v => !!v || 'กรุณากรอกเบอร์โทรศัพท์'
        ],
        confirmPasswordRules: [
          v => !!v || 'กรุณากรอกรหัสผ่าน'
        ]
      },
      itemsLogin: [
        'สำหรับผู้ซื้อทั่วไป',
        'สำหรับผู้ซื้อนิติบุลคล'
      ],
      tab: null,
      emailMarket: '',
      passwordMarket: '',
      checkClick: false,
      email: '',
      phone: '',
      items: [
        { header: 'เข้าสู่ระบบ' },
        { header: 'สมัครสมาชิก' }
      ],
      visibleLogin: false,
      visibleRegis: false,
      form: this.$form.createForm(this, { name: 'normal_login' }),
      FormRegister: this.$form.createForm(this, { name: 'register' })
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    localStorage.removeItem('_sellerShop')
    localStorage.removeItem('_selectProduct')
    localStorage.removeItem('_productToCal')
    localStorage.removeItem('_selectDataCartFirstTime')
    localStorage.removeItem('_productListCartLoginFirstTime')
    this.$EventBus.$emit('main', this.$route.name)
    this.$EventBus.$emit('checkpage', this.$route.name)
    var CurrentPath = this.$router.currentRoute.path
    localStorage.setItem('CurrentPath', CurrentPath)
  },
  methods: {
    link (val) {
      this.$router.replace({ path: `/${val}` }).catch(() => {})
    },
    async Login () {
      // console.log('this.$router.currentRoute.params.data', this.$router.currentRoute.path)
      var onedata = {}
      onedata.CurrentPath = this.$router.currentRoute.path
      // console.log(onedata)
      localStorage.setItem('oneData', Encode.encode(onedata))
      // console.log('ข้อมูล local', JSON.parse(Decode.decode(localStorage.getItem('oneData'))))
      window.location.assign(`${process.env.VUE_APP_REDIRECT}`)
    },
    forgetPassword (val) {
      this.$router.push({ path: `/${val}` }).catch(() => {})
    },
    // async LoginMarket () {
    //   if (this.$refs.Loginform.validate(true)) {
    //     var data = {
    //       email: this.username,
    //       password: this.password
    //     }
    //     // console.log(data)
    //     var LoginData = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/login_market`, data)
    //     console.log(LoginData.data)
    //     if (LoginData.data.result === 'SUCCESS') {
    //       this.$swal.fire({ text: `${LoginData.data.message}`, icon: 'success', timer: 2500, showConfirmButton: false })
    //       // var onedata = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
    //       var PathRedirect = localStorage.getItem('CurrentPath')
    //       if (PathRedirect === '/UPS' || PathRedirect === '/ups') {
    //         PathRedirect = 'UPS'
    //       } else if (PathRedirect === '/UPS/Register' || PathRedirect === '/UPS/Login') {
    //         PathRedirect = 'UPS'
    //       }
    //       var dataRole = {
    //         role: 'ext_buyer'
    //       }
    //       localStorage.setItem('roleUser', JSON.stringify(dataRole))
    //       var onedata = {}
    //       // console.log('onedata ====>', onedata)
    //       onedata.user = LoginData.data.data
    //       localStorage.setItem('oneData', Encode.encode(onedata))
    //       console.log(`${process.env.VUE_APP_DOMAIN}${PathRedirect}`)
    //       window.location.assign(`${process.env.VUE_APP_DOMAIN}${PathRedirect}`)
    //     } else {
    //       this.$swal.fire({ text: `${LoginData.data.message}`, icon: 'error', timer: 2500, showConfirmButton: false })
    //       this.password = ''
    //     }
    //   }
    // }
    async LoginMarket (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          var data = {
            email: values.emailMarket,
            password: values.passwordMarket
          }
          // console.log(data)
          var LoginData = await this.axios.post(`${process.env.VUE_APP_BACK_END}api/login_market`, data)
          // console.log(LoginData)
          if (LoginData.data.result === 'SUCCESS') {
            this.$swal.fire({ text: `${LoginData.data.message}`, icon: 'success', timer: 2500, showConfirmButton: false })
            values.emailMarket = ''
            values.passwordMarket = ''
            this.form.resetFields()
            var dataRole = {
              role: 'ext_buyer'
            }
            localStorage.setItem('roleUser', JSON.stringify(dataRole))
            var onedata = {}
            // console.log('onedata ====>', onedata)
            onedata.user = LoginData.data.data
            localStorage.setItem('oneData', Encode.encode(onedata))
            window.location.reload()
          } else {
            this.$swal.fire({ text: `${LoginData.data.message}`, icon: 'error', timer: 2500, showConfirmButton: false })
            this.passwordMarket = ''
            this.openModalLogin()
          }
        }
      })
    },
    LoginWithOTP () {
      this.$router.push({ path: '/otpLogin' }).catch(() => {})
    }
  }
}
</script>

<style scoped>
/* For Responsive mobile, Ipad, Website */
@media screen and (min-width: 360px) {
  .displayMobile {
    display: inline;
  }
  .displayIPAD {
    display: none;
  }
  .diaplayWeb {
    display: none;
  }
}
@media screen and (min-width: 768px) and (max-width: 1280px) {
  .displayIPAD {
    display: inline;
  }
  .displayMobile {
    display: none;
  }
  .diaplayWeb {
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  .displayIPAD {
    display: none;
  }
  .displayMobile {
    display: none;
  }
  .diaplayWeb {
    display: inline;
  }
}
</style>
